import { useContext, useState } from "react";
import {
  CustomIcon,
  CustomModal,
  CustomRange,
  TableHeader,
  TableNullData,
} from "../../../../../../components";
import values from "../../../../../../values";
import "./index.scss";
import Context from "../../../../../../context";
import UpdateFinancialGroup from "../update";
import { FINANCIAL_GROUP_TYPE } from "../../../../../../values/dropdownItems";
import utils from "../../../../../../utils";
import constants from "../../../../../../values/constants";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

type Props = {
  data?: any;
};

const Body = ({ data }: Props) => {
  // ============================================= Value Validation ==================================================

  const [editModal, setEditModal] = useState(false);
  const [selectedUserIndex, setSelectedUserIndex] = useState(0);

  const { showModal, setShowModal, setSelectedFinancialGroup } = useContext(
    Context.FinancialGroupScreen
  );

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const { t } = useTranslation();

  // ================================================ JSX Content ====================================================
  if (!data?.result?.docs || data?.result?.docs?.length <= 0)
    return <TableNullData />;
  return (
    <>
      <tbody id="financial-group-table-body-container">
        {data?.result?.docs?.map((financial: any, index: number) => {
          return (
            <tr key={`financial-tr-${index}`}>
              {/* financial name */}
              <td>
                <p>{financial?.name ? financial?.name : t("Unknown")}</p>
              </td>

              {/* financial calculate */}
              <td>
                <table id="financial-calculate-container">
                  <TableHeader
                    headers={values.tableHeaders.FINANCIAL_CHILD_GROUP_HEADERS.map(
                      (item) => t(item)
                    )}
                  />
                  <tbody>
                    <tr>
                      <td>{t("admin")}</td>
                      <td>
                        {financial?.subscriptionStudent?.share?.admin?.toLocaleString()}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("unicipality")}</td>
                      <td>
                        {financial?.subscriptionStudent?.share?.municipality?.toLocaleString()}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("superAgent")}</td>
                      <td>
                        {financial?.subscriptionStudent?.share?.superAgent?.toLocaleString()}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("company")}</td>
                      <td>
                        {financial?.subscriptionStudent?.share?.company?.toLocaleString()}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("driver")}</td>

                      <td>
                        {financial?.subscriptionStudent?.share?.driver?.toLocaleString()}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("tax")}</td>

                      <td>
                        {financial?.subscriptionStudent?.share?.tax?.toLocaleString()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                {financial?.agentSubscription
                  ? utils.convertNumberToPrice(financial?.agentSubscription) +
                    t("toman")
                  : "-"}
              </td>
              {/* financial day */}
              <td>{financial?.subscriptionAgent?.cycle?.toLocaleString()}</td>

              {/* financial price */}
              {/* <td>
                {financial.subscription.fee
                  ? financial.subscription.fee?.toLocaleString()
                  : "نامشخص"}
              </td> */}
              <td>
                {writePermission === "true" && (
                  <div className="i-actions">
                    <CustomIcon
                      icon="fas fa-pen"
                      hoverTitle={t("update")}
                      onClick={() => {
                        setSelectedFinancialGroup(financial);
                        setShowModal("UPDATE");
                      }}
                    />

                    <CustomIcon
                      icon="fas fa-trash"
                      hoverTitle={t("remove")}
                      onClick={() => {
                        setShowModal("DELETE");
                        setSelectedFinancialGroup(financial);
                      }}
                    />
                  </div>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
      {/* Edit Modal */}
      <CustomModal
        open={showModal === "UPDATE"}
        onClose={() => setShowModal("NONE")}
        label={t("update")}
        maxWidth={"45vw"}
        minWidth={"40vw"}
      >
        <UpdateFinancialGroup
          data={data?.result[selectedUserIndex]}
          onCancel={() => {}}
        />
      </CustomModal>

      {/* <UpdateFinancialGroup
        role="FINANCIAL_GROUP"
        open={editModal}
        onClose={() => setEditModal(!editModal)}
        data={data?.result[selectedUserIndex]}
      /> */}
      {/* Delete Modal */}
      {/* <DeleteModal
                  user={passenger}
                  open={deleteModal}
                  onClose={() => setDeleteModal(!deleteModal)}
                /> */}
    </>
  );
};

export default Body;
